<template>
  <div>
    <div class="row col-md-12 justify-content-center">
      <div class="jumbotron m-3">
        <div class="col-md-12 text-center mb-4" v-if="!post.postId">
          <h4>Carregando notícia...</h4>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>
        <div class="col-md-12" v-if="post.postId != 0">
          <h2 class="mb-5 text-center">{{ post.titulo }}</h2>
          <div class="m-2">
            <quill-editor v-model="post.mensagem" :options="editorOption" disabled></quill-editor>
          </div>
          <div class="text-center mt-3">
            <v-btn color="blue" text v-on:click="voltar()">Voltar</v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import router from "../router";
export default {
  data() {
    return {
      post: {
        postId: 0,
        titulo: "",
        categoriaId: 0,
        assunto: "",
        mensagem: "",
        imagem: "",
        dataPublicacao: null,
      },
      categorias: null,
      editorOption: {
        theme: "bubble",
        placeholder: "",
      },
    };
  },
  mounted() {
    this.getCategorias();
    this.getPost(this.$route.params.id);
  },
  methods: {
    getCategorias() {
      axios.get("https://www.sabios.net.br/api/categoria").then(
        (rs) => {
          this.categorias = rs.data;
        },
        (err) => console.log("Error: " + err)
      );
    },
    getPost(id) {
      axios.get(`/api/post/${id}`).then(
        (rs) => {
          this.post = rs.data;
        },
        (err) => console.log("Error: " + err)
      );
    },
    voltar() {
      router.push({ path: `/noticias` }).catch(()=>{});
    },
  },
};
</script>
<style scoped>
.ql-toolbar {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Noticia.vue